import { render, staticRenderFns } from "./aem-form-wrapper.vue?vue&type=template&id=1462f5ac"
import script from "./aem-form-wrapper.vue?vue&type=script&lang=ts"
export * from "./aem-form-wrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports